import './serverSettings.scss'
import { useServerSettingsData } from './ServerSettingsInitialization'
import { SiteDesignGetPayload } from '../../../lib/types'
import GenericServerSettings from './GenericServer/GenericServerSettings'
import HuskyServerSettings from './HuskyServer/HuskyServerSettings'
import Button from 'components/Button/Button'
import { ButtonStyles, ModalPopupSize } from 'lib/enums'
import ModalPopup from 'components/ModalPopup/ModalPopup'
import { useEffect } from 'react'

const ServerSettings = ({ siteDesignPayload, setModifiedServerSettings, updatedCameraAmount, setHasManagementServerValidationError }: ServerSettingsProps) => {
  const {
    formData,
    isOptionsSetupLoaded,
    cameraAmount,
    serverSettings,
    handleXProtectPlatformChange,
    handleValueChange,
    handleArchivingValueChange,
    handleStorageSetupValueChange,
    handleSupportedCamerasValueChange,
    hardwareTypeSelect,
    selectedHardwareType,
    onHandleRestoreDefaultsClick,
    handleModalConfirmRestoreDefaults,
    handleModalCancelRestoreDefaults,
    showRestoreDefaultModal,
    hasManagementServerValidationError,
    setHasManagementServerValidationError: setLocalValidationError
  } = useServerSettingsData(siteDesignPayload, setModifiedServerSettings, updatedCameraAmount)

  useEffect(() => {
    setHasManagementServerValidationError?.(hasManagementServerValidationError)
  }, [hasManagementServerValidationError, setHasManagementServerValidationError])

  return (
    <>
      {isOptionsSetupLoaded.current && (
        <>
          {selectedHardwareType === 0 && (
            <GenericServerSettings
              formData={formData}
              serverSettings={serverSettings}
              camerasAmount={cameraAmount}
              handleXProtectPlatformChange={handleXProtectPlatformChange}
              handleValueChange={handleValueChange}
              handleArchivingValueChange={handleArchivingValueChange}
              handleStorageSetupValueChange={handleStorageSetupValueChange}
              handleSupportedCamerasValueChange={handleSupportedCamerasValueChange}
              hardwareTypeSelect={hardwareTypeSelect}
              setHasManagementServerValidationError={setLocalValidationError}
            />
          )}
          {selectedHardwareType === 1 && (
            <HuskyServerSettings
              formData={formData}
              serverSettings={serverSettings}
              camerasAmount={cameraAmount}
              handleXProtectPlatformChange={handleXProtectPlatformChange}
              handleValueChange={handleValueChange}
              handleSupportedCamerasValueChange={handleSupportedCamerasValueChange}
              hardwareTypeSelect={hardwareTypeSelect}
              setHasManagementServerValidationError={setLocalValidationError}
            />
          )}

          <div className="row justify-content-start">
            <div className="col-12 text-end">
              <Button id={'xsd__e2e-restore-server-settings-button'} label="Defaults" onClickHandler={onHandleRestoreDefaultsClick} styling={ButtonStyles.Secondary} />
            </div>
          </div>

          <ModalPopup
            headline="Restore Default Server Settings"
            description="Are you sure you want to restore all default server settings? This will reset your configurations, including generic and Husky IVO settings."
            size={ModalPopupSize.Small}
            showModal={showRestoreDefaultModal}
            onCloseButtonclick={handleModalCancelRestoreDefaults}
            button1Style={ButtonStyles.Danger}
            button1Label="Yes, restore defaults"
            button1OnClickHandler={handleModalConfirmRestoreDefaults}
            button2Style={ButtonStyles.Tertiary}
            button2Label="Cancel"
            button2OnClickHandler={handleModalCancelRestoreDefaults}
          />
        </>
      )}
    </>
  )
}

export default ServerSettings

type ServerSettingsProps = {
  siteDesignPayload: SiteDesignGetPayload
  setModifiedServerSettings?
  updatedCameraAmount?
  onHandleRestoreDefaultsClick?
  setHasManagementServerValidationError?: (hasError: boolean) => void
}
